// src/App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CreditProvider } from "./context/CreditContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import SignIn from "./pages/SignIn";
import Profile from "./pages/Profile";
import Billing from "./pages/Billing";
function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CreditProvider>
          <Routes>
            {/* Public */}
            <Route path="/signin" element={<SignIn />} />
            {/* Protected */}
            <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/chat/:chatId" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
          </Routes>
        </CreditProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;

